"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _request = _interopRequireDefault(require("@/utils/request"));
var _default = exports.default = {
  watch: {
    datas: {
      handler: function handler() {
        /* 展开条目 */
        this.renderData();
      } /* nv, ov */,
      deep: true
    },
    '$attrs.data': {
      handler: function handler(nv, ov) {
        if (nv && (nv === null || nv === void 0 ? void 0 : nv.length) !== (ov === null || ov === void 0 ? void 0 : ov.length)) {
          this.handleStaticDatas();
        }
      },
      deep: true
    },
    'table.data': {
      handler: function handler(nv /* , ov */) {
        var _this = this;
        var rowKeyCount = {};
        nv === null || nv === void 0 || nv.forEach(function (data) {
          var key = _this.getRowKey(data);
          rowKeyCount[key] ? rowKeyCount[key]++ : rowKeyCount[key] = 1;
        });
        Object.keys(rowKeyCount).filter(function (key) {
          return rowKeyCount[key] > 1;
        }).forEach(function (key) {
          var _nv$filter;
          return (_nv$filter = nv.filter(function (data) {
            return key === _this.getRowKey(data);
          })) === null || _nv$filter === void 0 ? void 0 : _nv$filter.forEach(function (data) {
            var _this$table, _this$table2, _data$_this$table$row, _this$table3;
            return console.warn("\n\u8B66\u544A\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01", "\n\u8868\u683C\u884C rowkey \u952E\u503C\u91CD\u590D\uFF01\uFF01", "\n".concat(data[(_this$table = _this.table) === null || _this$table === void 0 ? void 0 : _this$table.rowKey] ? (_this$table2 = _this.table) === null || _this$table2 === void 0 ? void 0 : _this$table2.rowKey : 'id', ": ").concat((_data$_this$table$row = data[(_this$table3 = _this.table) === null || _this$table3 === void 0 ? void 0 : _this$table3.rowKey]) !== null && _data$_this$table$row !== void 0 ? _data$_this$table$row : data.id), "\n", data);
          });
        });
      },
      deep: true
    },
    'pagination.total': {
      handler: function handler() {
        this.renderData();
      } /* nv, ov */
    },
    'pagination.pageSize': {
      handler: function handler() {
        this.renderData();
      } /* nv, ov */
    },
    'pagination.currentPage': {
      handler: function handler() {
        this.renderData();
      } /* nv, ov */
    }
  },
  methods: {
    /** 获取 表格数据
     * @description: 获取 表格数据
     * @param { Object } options 请求参数
     * @param { Object } config 请求方法操作
     * @return { void }
     */
    getDatas: function getDatas(options, config) {
      var _this2 = this;
      if (this.loading) return;
      if (!this.openRequest && false) {
        this.loadingRequest.push({
          options: options,
          config: config
        });
        setTimeout(function () {
          return _this2.openRequest = true;
        }, 1500);
        return null;
      } else {
        var _this$getPagination = this.getPagination(),
          pageSize = _this$getPagination.pageSize,
          currentPage = _this$getPagination.currentPage;
        this.$nextTick(function () {
          /* 将数据源对象合并覆盖默认配置 */
          var option = _this2.$$deepMerge({
            data: {}
          }, _this2.dataSource, options);
          _this2.$$dataTypeOf(options, true) === '[object Object]' && ['data', 'params']
          // 判断传入的对象中是否包含 data 或 params 参数 ，并且为对象
          .filter(function (key) {
            return _this2.$$dataTypeOf(options[key], true) === '[object Object]';
          })
          // 判断 option 中该键的值数据类型是否为 对象，如果不是就让他是。方法中的1只是为了让 filter 的过滤条件始终为 true。如果用map会修改 map的数组 原值
          .filter(function (key) {
            return (_this2.$$dataTypeOf(option[key], true) !== '[object Object]' ? option[key] = {} : 1) || 1;
          }).forEach(function (key) {
            return Object.assign(option[key], options[key]);
          });
          Object.assign(option.data, {
            pageSize: pageSize,
            pageNum: currentPage
          });
          if (typeof option.params === 'function') option.params = option.params(option, _this2);

          /* 处理回调事件 */
          var $emit = _this2.$$listenersEmit;
          var alterNomenclature = _this2.$$alterNomenclature;
          var emitFun = function emitFun(name, data) {
            if (config) {
              var names1 = ['', 'sh', 'lh', '-', '_'];
              var names2 = names1.map(function (n) {
                return alterNomenclature(name, n);
              }); //alterNomenclature

              var n = names2.find(function (n1) {
                return typeof config[n1] === 'function';
              });
              if (n) return typeof config[n] === 'function' && config[n].apply(config, (0, _toConsumableArray2.default)(data));
            }
            _this2.$$listenersEmit.apply(_this2, [name].concat((0, _toConsumableArray2.default)(data)));
          };
          return new Promise(function (resolve, reject) {
            // 可以请求
            var canRequest = true;

            // 取消请求
            var stop = function stop() {
              return canRequest = false;
            };

            /* 请求前置操作 */
            emitFun('request-before', [options, stop, {
              stop: stop
            }, _this2]);
            if (canRequest) {
              _this2.loading = true;
              (0, _request.default)(option).then(function (res) {
                var _res$total;
                var datas = [];
                emitFun('request-then', [res, _this2]);
                resolve(res);
                if (res.code === 200) {
                  if (Array.isArray(res.rows)) datas = res.rows;else if (Array.isArray(res.data)) datas = res.data;
                  emitFun('request-success', [res, _this2]);
                } else {
                  emitFun('request-error', [res, _this2]);
                }
                _this2.table.data = datas;
                _this2.pagination.total = (_res$total = res.total) !== null && _res$total !== void 0 ? _res$total : datas.length;
                _this2.refreshExpandedDatas();
              }).catch(function (err) {
                emitFun('request-error', [err, _this2]);
                reject(err);
              }).finally(function () {
                _this2.doLayout();
                emitFun('request-over', [_this2]);
                emitFun('request-finally', [_this2]);
                setTimeout(function () {
                  return _this2.loading = false;
                }, 500);
              });
            } else {
              emitFun('request-over', [_this2]);
            }
          });
        });
      }
    },
    /** 处理静态数据
     * @description: 渲染数据到表格
     * @return { void }
     */
    handleStaticDatas: function handleStaticDatas() {
      var _this$datas, _this$$attrs$data;
      var _this$getPagination2 = this.getPagination(),
        pageSize = _this$getPagination2.pageSize,
        currentPage = _this$getPagination2.currentPage;
      var datas = [];
      if (((_this$datas = this.datas) === null || _this$datas === void 0 ? void 0 : _this$datas.length) > 0) datas.push.apply(datas, (0, _toConsumableArray2.default)(this.datas));else if (((_this$$attrs$data = this.$attrs.data) === null || _this$$attrs$data === void 0 ? void 0 : _this$$attrs$data.length) > 0) datas.push.apply(datas, (0, _toConsumableArray2.default)(this.$attrs.data));
      this.pagination.total = datas.length;
      this.table.data = datas.splice((currentPage - 1) * pageSize, pageSize);
    },
    /**
     * @description: 渲染数据到表格
     * @return { void }
     */
    renderData: function renderData() {
      if (this.staticTable) {
        this.handleStaticDatas();
      } else if (!this.staticTable && this.dataSource.url) {
        var _this$dataSource;
        ((_this$dataSource = this.dataSource) === null || _this$dataSource === void 0 ? void 0 : _this$dataSource.auto) && this.getDatas();
        // this.refreshExpandedDatas()
      } else this.table.data = [];
      this.renderTable();
    },
    /** 刷新展开的节点数据
     * @description: 刷新展开的节点数据
     * @return { void }
     */
    refreshExpandedDatas: function refreshExpandedDatas() {
      var _this3 = this;
      this.$nextTick(function () {
        var _this3$$refs$elTable;
        var states = (_this3$$refs$elTable = _this3.$refs['el-table']) === null || _this3$$refs$elTable === void 0 || (_this3$$refs$elTable = _this3$$refs$elTable.store) === null || _this3$$refs$elTable === void 0 ? void 0 : _this3$$refs$elTable.states;
        var isExpanded = function isExpanded(k) {
          var _states$treeData$k;
          return (_states$treeData$k = states.treeData[k]) === null || _states$treeData$k === void 0 ? void 0 : _states$treeData$k.expanded;
        };
        var getSubNode = function getSubNode(treeNode) {
          if (Array.isArray(treeNode.children)) return treeNode.children.filter(isExpanded);
          return false;
        };
        var _fun = function fun(k, parentKey) {
          var treeNode = states.treeData[k];
          if (!treeNode) return;

          /* 让节点 及 子节点 状态变更为加载中 */
          var _setNodeLoading = function setNodeLoading(key) {
            var _getSubNode;
            states.treeData[key].loading = true;
            (_getSubNode = getSubNode(states.treeData[key])) === null || _getSubNode === void 0 || _getSubNode.forEach(_setNodeLoading);
          };
          _setNodeLoading(k);
          _this3.getExpandedDatas(k, parentKey).then(function (data) {
            var _getSubNode2;
            // 挂在子节点
            states.lazyTreeNodeMap[k] = data;

            /* 当前节点的子节点数据挂在完成之后，判断当前节点是否有展开的子节点，继续获取 */
            (_getSubNode2 = getSubNode(treeNode)) === null || _getSubNode2 === void 0 || _getSubNode2.forEach(function (key) {
              return _fun(key, k);
            });
          }).finally(function () {
            states.treeData[k] && (states.treeData[k].loading = false);
            _this3.renderTable();
          });
        };

        /* 遍历表格的根数组 */
        _this3.table.data
        /* 获取根的 row-key */.map(_this3.getRowKey)
        /* 获取 展开的根 */.filter(isExpanded)
        /* 展开根刷新 */.forEach(_fun);
      });
    },
    /** 刷新懒加载的数据
     * @description: 获取懒加载的根节点的子数据，或者懒加载后的子节点的子数据
     * @param { String } key 要获取字节点数据的节点 row-key
     * @param { String } parentKey 父节点的 row-key，如果要获取的是子节点的子数据，那么这个参数是必要的
     * @return { void }
     */
    getExpandedDatas: function getExpandedDatas(key, parentKey) {
      var _this4 = this;
      /* 创建一个 异步对象 */
      return new Promise(function (resolve, reject) {
        var _this4$$refs$elTable, _ref, _this4$table;
        /* 获取表格的数据 */
        var states = _this4 === null || _this4 === void 0 || (_this4$$refs$elTable = _this4.$refs['el-table']) === null || _this4$$refs$elTable === void 0 || (_this4$$refs$elTable = _this4$$refs$elTable.store) === null || _this4$$refs$elTable === void 0 ? void 0 : _this4$$refs$elTable.states;
        /* 获取树结构的节点数据 */
        var treeNode = states.treeData[key];
        if (!treeNode) reject(new Error("\n\u5F53\u524D\u884C\u7684\u72B6\u6001\u65E0\u6CD5\u83B7\u53D6\nkey: ".concat(key)));

        /* 获取当前key 对应的条目数据
         * 如果节点是根节点，那么从 this.table.data 获取
         * 如果节点是根节点，那么从 懒加载 states.lazyTreeNodeMap 通过父节点 row-key 查找父节点下挂在的懒加载数据中查找 */
        var row = (_ref = [(_this4$table = _this4.table) === null || _this4$table === void 0 ? void 0 : _this4$table.data, states.lazyTreeNodeMap[key], states.lazyTreeNodeMap[parentKey]]) === null || _ref === void 0 || (_ref = _ref.find(function (datas) {
          return datas === null || datas === void 0 ? void 0 : datas.find(function (data) {
            return _this4.getRowKey(data) === key;
          });
        })) === null || _ref === void 0 ? void 0 : _ref.find(function (data) {
          return _this4.getRowKey(data) === key;
        });
        if (!row) return reject(new Error("\n\u5F53\u524D\u884C\u7684\u6570\u636E\u65E0\u6CD5\u83B7\u53D6\nkey: ".concat(key)));

        /* 超时抛错，如果长时间无法获取数据 */
        var a = setTimeout(function () {
          return reject(new Error('\n获取子数据失败'));
        }, 30000);

        /* 通过懒加载方法请求数据 */
        return _this4.load(row, treeNode, function (datas) {
          /* 返回成功 */
          resolve(datas);
          /* 清楚掉超时抛错 */
          clearTimeout(a);
        });
      });
    }
  }
};